const dkk = new Intl.NumberFormat('da-DK', {
  maximumFractionDigits: 0,
})

export function formatDkk(value: number): string {
  return `DKK ${dkk.format(Math.round(value))}`
}

export function formatNumber(value: number): string {
  return dkk.format(Math.round(value))
}

export function formatPercent(value: number, digits = 1): string {
  return `${value.toFixed(digits).replace('.', ',')}%`
}

export function formatMillions(value: number): string {
  return `DKK ${(value / 1_000_000).toFixed(2).replace('.', ',')}m`
}
